module.exports = require("core-js-pure/stable/object/entries");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/object/entries.js
// module id = 606
// module chunks = 0